import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const useRecaptchaToken = (): (() => Promise<string | undefined>) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  return useCallback(async () => {
    if (!executeRecaptcha) return undefined;
    return executeRecaptcha('submit');
  }, [executeRecaptcha]);
};
